import { DynamicFilter, DynamicFilterOperator } from "../DynamicFilter";

export class DateTimeFilter extends DynamicFilter {
  public operatorLabelsMap = {
    greaterThan: "is after",
    greaterThanOrEqual: "is on or after",
    lessThan: "is before",
    lessThanOrEqual: "is on or before",
  };

  public disabledOperators: DynamicFilterOperator[] = [
    "contains",
    "notContains",
    "in",
    "notIn",
  ];
}
